import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import { Badge } from '../../components/ui/badge';

const PrivacidadPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-teal-600 py-12">
        <div className="container-max mx-auto px-4 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-100 hover:text-white mb-4">
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
          <Badge className="bg-white/20 text-white hover:bg-white/20 mb-4">
            <Shield className="w-3 h-3 mr-1" />
            Legal
          </Badge>
          <h1 className="font-heading text-3xl md:text-4xl font-semibold text-white">
            Política de Privacidad
          </h1>
          <p className="text-teal-100 mt-2">Última actualización: [Fecha]</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding">
        <div className="container-max mx-auto">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-soft p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <h2>1. Responsable del tratamiento</h2>
              <p>
                <strong>[Razón Social]</strong>, RUT [RUT], con domicilio en [Dirección], [Ciudad], Chile.
              </p>
              <p>
                Email de contacto para privacidad: [privacidad@anonimamente.cl]
              </p>

              <h2>2. Principio de minimización de datos</h2>
              <p>
                En AnonimaMente aplicamos el principio de <strong>minimización de datos</strong>: 
                solo recopilamos la información estrictamente necesaria para prestar el servicio.
              </p>
              <p>
                <strong>NO solicitamos:</strong>
              </p>
              <ul>
                <li>Nombre real o legal</li>
                <li>RUT o documento de identidad</li>
                <li>Dirección física</li>
                <li>Historial médico previo</li>
              </ul>

              <h2>3. Datos que recopilamos</h2>
              <h3>3.1 Datos de sesión (usuarios/pacientes)</h3>
              <ul>
                <li><strong>Seudónimo:</strong> El nombre ficticio que eliges para tu sesión</li>
                <li><strong>Email (opcional):</strong> Solo si deseas recibir recordatorios</li>
                <li><strong>Fecha/hora de sesiones:</strong> Para gestión de agenda</li>
                <li><strong>ID de transacción:</strong> Referencia de pago (no datos de tarjeta completos)</li>
              </ul>

              <h3>3.2 Datos de profesionales</h3>
              <ul>
                <li>Nombre completo y credenciales profesionales</li>
                <li>Número de registro profesional</li>
                <li>Datos de contacto y bancarios para pagos</li>
              </ul>

              <h3>3.3 Datos técnicos</h3>
              <ul>
                <li>Dirección IP (anonimizada)</li>
                <li>Tipo de dispositivo y navegador</li>
                <li>Logs de acceso (para seguridad)</li>
              </ul>

              <h2>4. Sesiones de video - No grabación</h2>
              <p>
                Las sesiones de videollamada <strong>NUNCA se graban</strong> por parte de AnonimaMente. 
                El contenido de las conversaciones es confidencial entre el usuario y el profesional.
              </p>
              <p>
                Utilizamos Jitsi Meet como plataforma de videollamadas, configurado para no almacenar 
                ningún contenido de las sesiones.
              </p>

              <h2>5. Finalidades del tratamiento</h2>
              <p>Usamos tus datos para:</p>
              <ul>
                <li>Gestionar el agendamiento de citas</li>
                <li>Procesar pagos y emitir boletas</li>
                <li>Enviar recordatorios (si proporcionas email)</li>
                <li>Mejorar el servicio (datos agregados y anónimos)</li>
                <li>Cumplir obligaciones legales</li>
              </ul>

              <h2>6. Bases legales del tratamiento</h2>
              <ul>
                <li><strong>Consentimiento:</strong> Al aceptar estos términos y el consentimiento informado</li>
                <li><strong>Ejecución contractual:</strong> Para prestar el servicio contratado</li>
                <li><strong>Obligaciones legales:</strong> Emisión de boletas, reportes tributarios</li>
              </ul>

              <h2>7. Compartición de datos</h2>
              <p>
                <strong>No vendemos ni compartimos</strong> tus datos con terceros para fines comerciales.
              </p>
              <p>Solo compartimos datos con:</p>
              <ul>
                <li><strong>Procesadores de pago:</strong> Para completar transacciones (solo datos necesarios)</li>
                <li><strong>Tu psicólogo:</strong> Solo tu seudónimo y hora de cita</li>
                <li><strong>Autoridades:</strong> Solo si es requerido legalmente</li>
              </ul>

              <h2>8. Reportes para empresas (B2B)</h2>
              <p>
                Para clientes corporativos, aplicamos <strong>k-anonymity</strong>: solo entregamos 
                reportes agregados cuando hay mínimo 10 usuarios. Nunca reportamos identidades individuales.
              </p>

              <h2>9. Retención de datos</h2>
              <ul>
                <li><strong>Datos de sesión:</strong> 12 meses desde la última actividad</li>
                <li><strong>Datos de pago:</strong> Según obligaciones tributarias (generalmente 6 años)</li>
                <li><strong>Logs técnicos:</strong> 30 días</li>
              </ul>

              <h2>10. Tus derechos (ARCO)</h2>
              <p>
                Tienes derecho a:
              </p>
              <ul>
                <li><strong>Acceso:</strong> Solicitar qué datos tenemos sobre ti</li>
                <li><strong>Rectificación:</strong> Corregir datos incorrectos</li>
                <li><strong>Cancelación:</strong> Solicitar eliminación de tus datos</li>
                <li><strong>Oposición:</strong> Oponerte a ciertos tratamientos</li>
              </ul>
              <p>
                Para ejercer estos derechos, contacta a [privacidad@anonimamente.cl] indicando 
                tu seudónimo o ID de reserva.
              </p>

              <h2>11. Cookies</h2>
              <p>
                Usamos cookies esenciales para el funcionamiento del sitio y cookies analíticas 
                (opcional) para mejorar el servicio. Puedes gestionar tus preferencias en cualquier momento.
              </p>

              <h2>12. Seguridad</h2>
              <p>
                Implementamos medidas técnicas y organizativas para proteger tus datos:
              </p>
              <ul>
                <li>Cifrado en tránsito (HTTPS/TLS)</li>
                <li>Acceso restringido a datos</li>
                <li>Monitoreo de seguridad</li>
              </ul>

              <h2>13. Cambios a esta política</h2>
              <p>
                Notificaremos cambios materiales con al menos 15 días de anticipación a través 
                del sitio web.
              </p>

              <h2>14. Contacto</h2>
              <p>
                Para consultas sobre privacidad: [privacidad@anonimamente.cl]
              </p>

              <hr className="my-8" />

              <p className="text-sm text-slate-500">
                Esta política cumple con la Ley 19.628 sobre Protección de la Vida Privada de Chile.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacidadPage;
